import { createSlice } from '@reduxjs/toolkit'
import { get } from 'lodash'

const initialState = {
  addBeneficialOwnerContact: {
    isOpen: false,
    accountId: '',
    initialFirstName: '',
    initialLastName: '',
    initialMethodValue: '',
    parent: '',
  },
}

const beneficialOwnerContactsSlice = createSlice({
  name: 'beneficialOwnerContacts',
  initialState,
  reducers: {
    setAddBeneficialOwnerContactState: (state, action) => {
      state.addContact = action.payload
    },
    setIsOpenAddBeneficialOwnerContact: (state, action) => {
      state.addBeneficialOwnerContact.isOpen = action.payload
    },
    openAddBeneficialOwnerContact: (state, action) => {
      state.addBeneficialOwnerContact.isOpen = true
    },
    closeAddBeneficialOwnerContact: (state, action) => {
      state.addBeneficialOwnerContact.isOpen = false
    },
    resetAddBeneficialOwnerContact: (state, action) => {
      state.addBeneficialOwnerContact = initialState.addBeneficialOwnerContact
    },
  },
})
export const {
  setAddBeneficialOwnerContactState,
  closeAddBeneficialOwnerContact,
  setIsOpenAddBeneficialOwnerContact,
  openAddBeneficialOwnerContact,
  resetAddBeneficialOwnerContact,
} = beneficialOwnerContactsSlice.actions

export const selectIsOpenAddBeneficialOwnerContact = s => get(s, 'beneficialOwnerContacts.addBeneficialOwnerContact.isOpen', false)
export const selectAddBeneficialOwnerContact = s => get(s, 'beneficialOwnerContacts.addBeneficialOwnerContact', {})

export default beneficialOwnerContactsSlice.reducer
